module.exports = __webpack_public_path__ + "static/media/editIcon.97c02502.svg";